module.exports = __webpack_public_path__ + "static/media/Forward.c1d9d01a.svg";